export default __webpack_public_path__ + "static/media/Nunito-SemiBold.03392c01.woff";